import type { ClaimsSortId, SettlementSort } from '../types';

export const CLAIMS_SORT_OPTIONS: Array<{ id: ClaimsSortId; label: string; apiSort: SettlementSort }> =
  [
    { id: 'featured', label: 'Featured', apiSort: 'featured' },
    { id: 'popular', label: 'Most popular', apiSort: 'recent' },
    { id: 'payout', label: 'Highest payout', apiSort: 'payout' },
    { id: 'deadline', label: 'Closing Soon', apiSort: 'deadline' },
    { id: 'name', label: 'A to Z', apiSort: 'name' },
  ];
